import { ChartColor } from '@chart';

import styles from './MiniLegend.module.scss';

export interface MiniLegendProps {
  labels: string[];
  colors: ChartColor[];
}

export const MiniLegend = ({ labels, colors }: MiniLegendProps) => {
  return (
    <div className={styles.miniLegendRoot} data-testid="mini-legend">
      {labels.map((label, index) => {
        return (
          <div className={styles.item} key={label}>
            <div
              className={styles.dot}
              style={{ backgroundColor: colors[index].value }}
            />
            <span className={styles.label}>{label}</span>
          </div>
        );
      })}
    </div>
  );
};
